import React from "react";
import { FiUpload } from "react-icons/fi";

const UploadClassWork = ({ navigateToAddAssignment }) => {
  return (
    <div className="">
      <div
        className="bg-white rounded-lg w-[300px] h-[390px] p-4 flex justify-center items-center border border-[#67748E]"
        onClick={navigateToAddAssignment}
      >
        <button className="flex justify-center items-center flex-col">
          <span className="mb-3">
            <FiUpload size={25} />
          </span>
          <span className="text-[#67748E] font-Nunito text-[16px]">
            Upload New Classwork
          </span>
        </button>
      </div>
    </div>
  );
};

export default UploadClassWork;
